import { DIRECTOR_FORM_OPEN, DIRECTOR_ID } from '../../../constants'
import { useQuery, useUpdateUrlParams } from '../../../hooks'

export const useManageDirectorsUrlParams = () => {
  const isFormOpen = useQuery().get(DIRECTOR_FORM_OPEN)
  const setIsFormOpen = useUpdateUrlParams(DIRECTOR_FORM_OPEN)

  const directorId = useQuery().get(DIRECTOR_ID)
  const setDirectorId = useUpdateUrlParams(DIRECTOR_ID)

  return { isFormOpen, setIsFormOpen, directorId, setDirectorId }
}
